
<template>
    <div>

        <Navbar/>
        <b-container class="d-flex justify-content-center mt-5" style="min-height:50vh;">
            <div style="width: 250px; height: 50vh;" class="" v-if="isLoading">
                <div class="loader ml-4"></div>
                <h3>Loading Quote<span class="loading"></span></h3>
            </div>
            <div v-if="isExistingQuote">
                <b-alert variant="info" show>
                    <h4>Existing Order Number: {{ quote.existing_invoice_id }}</h4>
                    <p>This quote has already been converted to an order.</p>
                    <p>If you need to make changes or require assistance, please contact our support team.</p>
                </b-alert>
            </div>
            <div v-if="isAdoption">
                <b-alert variant="info" show>
                    <h4>Existing Order Number: {{ quote.existing_invoice_id }}</h4>
                    <p>This order cannot be placed on the store.</p>
                    <p>If you need to make changes or require assistance, please contact your adoption specialist.</p>
                </b-alert>
            </div>
            <b-alert v-if="error" variant="danger" show>
                {{ error }}
            </b-alert>
<!--            Code: {{code}} <br/>-->
<!--            Signature: {{signature}}-->
<!--            <br/>-->
<!--            <br/>-->
<!--            <br/>-->
<!--            <div v-if="quote">{{quote}}</div>-->
        </b-container>
        <Footer/>
    </div>
</template>
<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import {mapState} from "vuex";

export default {
    name: 'quoteCheckoutLanding',
    components: {Footer, Navbar},
    props: ['code', 'signature'],
    data: () => ({
        quote: {},
        isLoading: false,
        error: null,
        isExistingQuote: false,
        isAdoption: false,
    }),
    created() {
        if (!this.$auth.check()) {
            this.$router.push({name: 'login', query: {redirect: this.$route.fullPath}});
            return;
        }
        this.getQuote();
    },
    methods: {
        getQuote() {
            this.isLoading = true;
            this.axios.get(`/checkout/quote/${this.code}/${this.signature}`)
                .then((response => {
                    this.quote = response.data;
                    // Already ordered
                    if (this.quote.already_ordered) {
                        this.isExistingQuote = true;
                        this.$store.commit('setQuote', null);
                        return;
                    }
                    // is adoption
                    if (this.quote.is_adoption > 0) {
                        this.isAdoption = true;
                        this.$store.commit('setQuote', null);
                        return;
                    }

                    this.$store.commit('setQuote', this.quote);
                    this.$router.push('/checkout')
                }))
                .catch((error) => {
                    this.error = error.message;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
}
</script>

<style scoped lang="scss">
.loading::after {
    display: inline-block;
    animation: dotty steps(1,end) 1s infinite;
    content: '';
}

@keyframes dotty {
    0%   { content: ''; }
    25%  { content: '.'; }
    50%  { content: '..'; }
    75%  { content: '...'; }
    100% { content: ''; }
}
.loader {
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
}
@-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>